import { render, staticRenderFns } from "./wetLabData.vue?vue&type=template&id=7bb6d8f7"
import script from "./wetLabData.vue?vue&type=script&lang=js"
export * from "./wetLabData.vue?vue&type=script&lang=js"
import style0 from "./wetLabData.vue?vue&type=style&index=0&id=7bb6d8f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports